"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** Renders central text in the pie chart*/const renderTextContent = (num, title) => props => {
  const {
    cx,
    cy,
    fill
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TextContent, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("text", {
      x: cx,
      y: cy,
      textAnchor: "middle",
      fill: fill,
      role: "text",
      "aria-label": `${title ? title : ''} ${num}`,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("tspan", {
        pointerEvents: "none",
        x: cx,
        y: cy,
        dy: 10,
        fontSize: 48,
        textAnchor: "middle",
        fill: "#000000",
        children: num
      }), title && /*#__PURE__*/(0, _jsxRuntime.jsx)("tspan", {
        pointerEvents: "none",
        x: cx,
        y: cy,
        dy: 32,
        fontSize: 14,
        textAnchor: "middle",
        fill: "#00000060",
        opacity: 0.6,
        children: title
      })]
    })
  });
};
var _default = exports.default = renderTextContent;